import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("static-filter", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-static-filter></ux-static-filter>`);
        const el = await page.find("ux-static-filter");
        expect(el).toHaveClass("hydrated");
    });

    it("matches snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-static-filter></ux-static-filter>`);
        const el = await page.find("ux-static-filter");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("filters correct items", async () => {
        const page = await newE2EPage();
        await page.setContent(template());
        const uxDropdown = await page.find("ux-dropdown");
        const uxRadioListItem1 = await page.find("ux-radio-list-item[value='1']");
        const uxRadioListItem2 = await page.find("ux-radio-list-item[value='2']");
        const uxRadioListItem3 = await page.find("ux-radio-list-item[value='3']");
        await page.waitForChanges();
        const element1 = await page.find(".one");
        const element2 = await page.find(".two");
        const element3 = await page.find(".three");
        /** other dependencies are present to this specific class, do not change it */
        const hiddenClass = "ux-static-filter__item--hidden";
        expect(element1).not.toHaveClass(hiddenClass);
        expect(element2).not.toHaveClass(hiddenClass);
        expect(element3).not.toHaveClass(hiddenClass);
        await page.waitForChanges();
        await uxDropdown.click();
        await page.waitForChanges();
        await uxRadioListItem2.click();
        await page.waitForChanges();
        expect(element1).toHaveClass(hiddenClass);
        expect(element2).not.toHaveClass(hiddenClass);
        expect(element3).toHaveClass(hiddenClass);
        await uxDropdown.click();
        await page.waitForChanges();
        await uxRadioListItem1.click();
        await page.waitForChanges();
        expect(element1).not.toHaveClass(hiddenClass);
        expect(element2).toHaveClass(hiddenClass);
        expect(element3).toHaveClass(hiddenClass);
        await uxDropdown.click();
        await page.waitForChanges();
        await uxRadioListItem3.click();
        await page.waitForChanges();
        expect(element1).toHaveClass(hiddenClass);
        expect(element2).toHaveClass(hiddenClass);
        expect(element3).not.toHaveClass(hiddenClass);
    });

    it("filters correct items with name changer attribute", async () => {
        const page = await newE2EPage();
        await page.setContent(template(true));
        const uxDropdown = await page.find("ux-dropdown");
        const uxRadioListItem1 = await page.find("ux-radio-list-item[value='1']");
        const uxRadioListItem2 = await page.find("ux-radio-list-item[value='2']");
        const uxRadioListItem3 = await page.find("ux-radio-list-item[value='3']");
        await page.waitForChanges();
        const element1 = await page.find(".one");
        const element2 = await page.find(".two");
        const element3 = await page.find(".three");
        /** other dependencies are present to this specific class, do not change it */
        const hiddenClass = "ux-static-filter__item--hidden";
        expect(element1).not.toHaveClass(hiddenClass);
        expect(element2).not.toHaveClass(hiddenClass);
        expect(element3).not.toHaveClass(hiddenClass);
        await page.waitForChanges();
        await uxDropdown.click();
        await page.waitForChanges();
        await uxRadioListItem2.click();
        await page.waitForChanges();
        expect(element1).toHaveClass(hiddenClass);
        expect(element2).not.toHaveClass(hiddenClass);
        expect(element3).toHaveClass(hiddenClass);
        await uxDropdown.click();
        await page.waitForChanges();
        await uxRadioListItem1.click();
        await page.waitForChanges();
        expect(element1).not.toHaveClass(hiddenClass);
        expect(element2).toHaveClass(hiddenClass);
        expect(element3).toHaveClass(hiddenClass);
        await uxDropdown.click();
        await page.waitForChanges();
        await uxRadioListItem3.click();
        await page.waitForChanges();
        expect(element1).toHaveClass(hiddenClass);
        expect(element2).toHaveClass(hiddenClass);
        expect(element3).not.toHaveClass(hiddenClass);
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-static-filter></ux-static-filter>`);
    });
});

export const template = (nameAttribute = false) => `
<ux-static-filter display-all-values="${nameAttribute ? `tool` : `machine`}=">
    <ux-dropdown>
        <ux-radio-list-item ${
            nameAttribute ? `data-ux-static-filter-name="tool"` : ``
        } name="machine" value="" checked></ux-radio-list-item>
        <ux-radio-list-item ${
            nameAttribute ? `data-ux-static-filter-name="tool"` : ``
        } name="machine" value="1"></ux-radio-list-item>
        <ux-radio-list-item ${
            nameAttribute ? `data-ux-static-filter-name="tool"` : ``
        } name="machine" value="2"></ux-radio-list-item>
        <ux-radio-list-item ${
            nameAttribute ? `data-ux-static-filter-name="tool"` : ``
        } name="machine" value="3"></ux-radio-list-item>
    </ux-dropdown>
    <ux-radio-button name="test" label="test"></ux-radio-button>
    <ux-radio-button name="test-2" label="test-2"></ux-radio-button>
    <div class="one" data-ux-static-filter="${nameAttribute ? `tool` : `machine`}=1">1</div>
    <div class="two" data-ux-static-filter="${nameAttribute ? `tool` : `machine`}=2">2</div>
    <div class="three" data-ux-static-filter="${nameAttribute ? `tool` : `machine`}=3">3</div>
</ux-static-filter>
`;
